
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, getDocs, query, orderBy, limit, onSnapshot, serverTimestamp, where, doc, updateDoc, increment } from 'firebase/firestore';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = { 
  apiKey: "AIzaSyCadpU4RKaj2k6buiJD96DwbYLhw1XDPw8", 
  authDomain: "memecoin-castle.firebaseapp.com", 
  projectId: "memecoin-castle", 
  storageBucket: "memecoin-castle.firebasestorage.app", 
  messagingSenderId: "211947577032", 
  appId: "1:211947577032:web:1b85cfeca1e245faf6cffd", 
  measurementId: "G-SNF0T0999C" 
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// --- User Identity Helpers ---

const ADJECTIVES = ['Based', 'Degen', 'Diamond', 'Paper', 'Chad', 'Wagie', 'Ape', 'Whale', 'Rich', 'Poor', 'Smug'];
const NOUNS = ['Handz', 'Enjoyer', 'Maxi', 'Holder', 'Sniper', 'Pumper', 'Short', 'Long', 'Wojak', 'Olek'];

const generateUsername = () => {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)];
  const num = Math.floor(Math.random() * 999);
  return `${adj}${noun}_${num}`;
};

export const getCurrentUsername = () => {
  let name = localStorage.getItem('olek_username');
  if (!name) {
    name = generateUsername();
    localStorage.setItem('olek_username', name);
  }
  return name;
};

// Authentication Helper
export const signInUser = async () => {
  // Ensure username exists
  getCurrentUsername();

  onAuthStateChanged(auth, (user) => {
    if (user) {
      console.log("Authenticated as:", user.uid);
    } else {
      signInAnonymously(auth)
        .then((cred) => console.log("New anonymous login:", cred.user.uid))
        .catch((error) => console.error("Auth error", error));
    }
  });
};

// --- Database Helpers ---

// 1. Board / Chat
export const subscribeToPosts = (callback: (posts: any[]) => void) => {
  const q = query(collection(db, 'olek_posts'), orderBy('timestamp', 'desc'), limit(50));
  return onSnapshot(q, (snapshot) => {
    const posts = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(posts);
  });
};

export const addPost = async (content: string) => {
  try {
    const author = getCurrentUsername();
    await addDoc(collection(db, 'olek_posts'), {
      content,
      author,
      timestamp: Date.now(),
      likes: 0
    });
  } catch (e) {
    console.error("Error adding post: ", e);
  }
};

// 2. Gallery
export const saveToGallery = async (imageData: string, prompt: string, type: 'meme' | 'pfp') => {
  try {
    const user = auth.currentUser;
    const authorName = getCurrentUsername();
    
    await addDoc(collection(db, 'olek_gallery'), {
      imageUrl: imageData, 
      prompt,
      type,
      creatorId: user ? user.uid : 'anon',
      authorName: authorName,
      timestamp: serverTimestamp(),
      likes: 0
    });
    console.log("Auto-saved to Vault");
    return true;
  } catch (e) {
    console.error("Error saving to gallery: ", e);
    return false;
  }
};

// Only show memes in the vault, hide PFPs
// FIX: Removed 'where' clause to prevent Indexing Errors on new collections
export const subscribeToGallery = (callback: (images: any[]) => void) => {
  const q = query(
    collection(db, 'olek_gallery'), 
    orderBy('timestamp', 'desc'), 
    limit(50)
  );
  
  return onSnapshot(q, (snapshot) => {
    const images = snapshot.docs
      .map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
      // Filter client-side to avoid Index requirements
      .filter((doc: any) => doc.type === 'meme');
      
    callback(images);
  });
};

export const likeGalleryImage = async (imageId: string) => {
  // Prevent double voting locally
  const likedKey = `liked_${imageId}`;
  if (localStorage.getItem(likedKey)) return;

  try {
    const ref = doc(db, 'olek_gallery', imageId);
    await updateDoc(ref, {
      likes: increment(1)
    });
    localStorage.setItem(likedKey, 'true');
  } catch (e) {
    console.error("Error liking image:", e);
  }
};
